/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PurchaserInfoResponseDTO interface.
 */
export function instanceOfPurchaserInfoResponseDTO(value) {
    return true;
}
export function PurchaserInfoResponseDTOFromJSON(json) {
    return PurchaserInfoResponseDTOFromJSONTyped(json, false);
}
export function PurchaserInfoResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'city': json['city'] == null ? undefined : json['city'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
        'buyerName': json['buyerName'] == null ? undefined : json['buyerName'],
        'company': json['company'] == null ? undefined : json['company'],
        'addressLine': json['addressLine'] == null ? undefined : json['addressLine'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'state': json['state'] == null ? undefined : json['state'],
        'buyerEmail': json['buyerEmail'] == null ? undefined : json['buyerEmail'],
    };
}
export function PurchaserInfoResponseDTOToJSON(json) {
    return PurchaserInfoResponseDTOToJSONTyped(json, false);
}
export function PurchaserInfoResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'city': value['city'],
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
        'addressType': value['addressType'],
        'buyerName': value['buyerName'],
        'company': value['company'],
        'addressLine': value['addressLine'],
        'phone': value['phone'],
        'state': value['state'],
        'buyerEmail': value['buyerEmail'],
    };
}
